interface HourConfigFieldProps {
  label: string
  value: number
  onChange: (value: number) => void
  description?: string
}

export function HourConfigField({ label, value, onChange, description }: HourConfigFieldProps) {
  return (
    <div className="flex items-center justify-between py-3 border-b border-[var(--border-color)] last:border-b-0">
      <div className="flex-1">
        <p className="text-sm text-[var(--text-primary)]">{label}</p>
        {description && <p className="text-xs text-[var(--text-muted)] mt-0.5">{description}</p>}
      </div>
      <div className="flex items-center gap-2">
        <input
          type="number"
          value={value}
          onChange={(e) => onChange(parseFloat(e.target.value) || 0)}
          className="w-20 bg-[var(--bg-tertiary)] border border-[var(--border-color)] rounded-lg px-3 py-2 text-sm text-[var(--text-primary)] text-right"
          min="0"
          step="0.5"
        />
        <span className="text-xs text-[var(--text-muted)] w-10">hrs</span>
      </div>
    </div>
  )
}
